import { render, staticRenderFns } from "./PatreonAccess.vue?vue&type=template&id=6ff0ef10&scoped=true"
import script from "./PatreonAccess.vue?vue&type=script&lang=js"
export * from "./PatreonAccess.vue?vue&type=script&lang=js"
import style0 from "./PatreonAccess.vue?vue&type=style&index=0&id=6ff0ef10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff0ef10",
  null
  
)

export default component.exports